import config from 'services/table/const';
import { formatDate } from 'utilities/common';
import Action from './table.action';
import { currencyFormat } from 'utilities/common';

let table = { ...config };

table.url = '/finance/payable';
table.columns = {
  code: {
    title: 'Kode',
    sortable: true,
    width: 150,
    component: (row) => {
      return (
        <div className="table-col">
          <div className="text-ellipsis fs-8 fw-semibold text-uppercase">
            {row?.code}
          </div>
          {row?.ref_code && (
            <small className="info">
              {row?.ref_code}
            </small>
          )}
          <small className="info">
            {formatDate(row?.schedule_at, 'DD/MM/YYYY') || '-'}
          </small>
        </div>
      );
    },
  },
  type: {
    title: 'Tipe',
    sortable: true,
    width: 150,
    component: (row) => {
      return (
        <div className="table-col">
          <div className="text-ellipsis fs-8 fw-semibold text-uppercase">
            {row?.type?.replace('_', ' ')}
          </div>
        </div>
      );
    },
  },

  vendor_id: {
    title: 'Vendor',
    alias: 'vendor.id',
    sortable: true,
    width: 120,
    class: '',
    component: (row) => {
      return (
        <div className="table-col">
          <div className="text-ellipsis fs-8 fw-semibold text-uppercase">
            {row?.vendor?.name}
          </div>
          <small className="info text-uppercase">
            {row?.vendor?.pic_name} - {row?.vendor?.pic_phone}
          </small>
        </div>
      );
    },
  },

  purchase_order_id: {
    title: 'PO',
    alias: 'purchase_order.id',
    sortable: true,
    width: 120,
    class: '',
    component: (row) => {
      return (
        <div className="table-col">
          <div className="text-ellipsis fs-8 fw-semibold text-uppercase">
            {row?.purchase_order?.code}
          </div>
        </div>
      );
    },
  },

  project_id: {
    title: 'Project',
    sortable: false,
    width: 100,
    class: '',
    component: (row) => {
      return (
        <div className="table-col">
          {row?.projects?.map((p) => (
            <small className='info'>- {p?.name}</small>
          ))}
        </div>
      );
    },
  },

  periode_project: {
    title: 'Periode',
    sortable: true,
    width: 100,
    class: '',
    component: (row) => {
      return (
        <div className="table-col">
          <div className="text-ellipsis fs-8 text-uppercase">
            {formatDate(row?.periode_project,'YYYYMM')}
          </div>
        </div>
      );
    },
  },

  due_at: {
    title: 'Jatuh Tempo',
    sortable: false,
    width: 100,
    class: 'text-center',
    classHeader: 'text-center',
    component: (row) => {
      return (
        <div className="text-ellipsis">
          {formatDate(row?.due_at, 'DD/MM/YYYY')}
        </div>
      );
    },
  },

  total_paid: {
    title: 'Sisa Tagihan',
    sortable: false,
    width: 100,
    class: 'text-end',
    classHeader: 'text-end',
    component: (row) => {
      return (
        <div className="text-ellipsis">
          {currencyFormat(row?.total_charges - row?.total_paid)}
        </div>
      );
    },
  },

  total_charges: {
    title: 'Total Harga',
    format_number: true,
    sortable: false,
    width: 100,
    class: 'text-end',
    classHeader: 'text-end',
  },

  document_status: {
    title: 'Status',
    sortable: true,
    class: 'text-center',
    classHeader: 'text-center',
    width: 100,
    component: (row) => {
      return (
        <span className={`badge status-${row?.document_status}-lt ms-auto `}>
          {row?.document_status?.replace('_', ' ')}
        </span>
      );
    },
  },

  action: {
    title: '',
    sortable: false,
    width: 50,
    class: 'text-end',
    component: (row) => {
      return <Action data={row} />;
    },
  },
};

export default table;
